import { render, staticRenderFns } from "./ucContact.vue?vue&type=template&id=dfc71670&"
import script from "./ucContact.vue?vue&type=script&lang=js&"
export * from "./ucContact.vue?vue&type=script&lang=js&"
import style0 from "./ucContact.vue?vue&type=style&index=0&id=dfc71670&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports